var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('navigation',{attrs:{"id":"navi"}}),_c('v-main',{staticClass:"d-flex align-self-center",staticStyle:{"max-width":"2480px","width":"100%"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }